import React from "react";
import { ControllerRenderProps, FieldError } from "react-hook-form";
import { ChoiceOptions, ValidationConstraints } from "@/components/tasks/types";
import ValidationEditor from "./shared/ValidationEditor";
import ChoiceEditor from "./shared/ChoiceEditor";

interface DropdownProps {
  name?: string;
  options: ChoiceOptions;
  field: ControllerRenderProps;
  error?: FieldError;
  readOnly?: boolean;
}

export default function Dropdown({
  name,
  options,
  field,
  error,
  readOnly,
}: DropdownProps) {
  return (
    <div className="space-y-2">
      <select
        {...field}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white ${
          error ? "border-red-500" : "border-gray-300"
        }`}
        disabled={readOnly}
      >
        <option value="">Select {name?.toLowerCase()}...</option>
        {options.choices.map((choice, index) => (
          <option key={index} value={choice.value || choice.name}>
            {choice.name}
          </option>
        ))}
      </select>
      {error && <p className="text-sm text-red-600 mt-1">{error.message}</p>}
    </div>
  );
}

interface DropdownEditorProps {
  options: ChoiceOptions;
  validation: ValidationConstraints;
  onOptionsChange: (options: ChoiceOptions) => void;
  onValidationChange: (validation: ValidationConstraints) => void;
}

Dropdown.Editor = function DropdownEditor({
  options,
  validation,
  onOptionsChange,
  onValidationChange,
}: DropdownEditorProps) {
  return (
    <div className="space-y-3">
      <ChoiceEditor
        choices={options.choices}
        onChoicesChange={(choices) => onOptionsChange({ ...options, choices })}
      />

      <ValidationEditor
        validation={validation}
        promptType="dropdown"
        onValidationChange={onValidationChange}
      />
    </div>
  );
};
